import React from 'react';

import CurrencyInput from 'react-currency-input-field';
import { Container, Label } from './styles';

function Input({ name, value, label, status, change }) {
  
  const handleValueChange = (newValue) => {
    // newValue é a string numérica ou undefined
    let finalValue = newValue;

    if (newValue !== undefined && newValue !== null) {
        const numericValue = parseFloat(newValue);
        if (!isNaN(numericValue)) {
            // Limita o valor entre 0 e 100
            if (numericValue > 100) {
                finalValue = '100';
            } else if (numericValue < 0) { 
                // Embora allowNegativeValue seja false, adicionamos por segurança
                finalValue = '0'; 
            }
        }
        // Converte o ponto para vírgula para manter compatibilidade com o formato pt-BR
        finalValue = String(finalValue).replace('.', ',');
    }
    // Chama a função change do pai com o valor validado (ou undefined se limpo)
    change(finalValue);
  };
  
  const handleBlur = () => {
    if (value !== undefined && value !== null && value !== '') {
      const rawNum = parseFloat(String(value).replace(',', '.'));
      if (!isNaN(rawNum)) {
        change(rawNum.toFixed(2).replace('.', ','));
      }
    }
  };
  
  return (
    <Container status={status.status}>
      <Label status={status.status}>{label}</Label>
      <CurrencyInput
        suffix="%"
        intlConfig={{ locale: 'pt-BR' }}
        id={name || "input-percentage"} // Usa name para id ou um padrão
        name={name}
        value={value}
        allowNegativeValue={false}
        disableGroupSeparators
        decimalsLimit={2} // Correto para react-currency-input-field
        onValueChange={handleValueChange} // Usa apenas onValueChange
        onBlur={handleBlur}
        // Remove o onChange customizado
      />
      <div className="feedback">{status.feedback}</div>
    </Container>
  );
}

export default Input;
